import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles } from "../shared/styles";
import { useIsMobile } from "../shared/utils";
import { LuFileText } from "react-icons/lu";

const formatSize = (bytes) => {
  if (!bytes) return "";
  const mb = bytes / (1024 * 1024);
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;
};

const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-AU", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

// Training material shared with this tech.
//
// The list is whatever the API returns, and the API returns only documents that
// are switched on AND name this user — both filters are applied server-side on
// the queryset, so there is nothing to hide here.
//
// No download control. Opening a document hands it to the browser's own PDF
// viewer, which renders it in place; that viewer has Save and Print buttons of
// its own that cannot be removed, so this is "we don't offer a copy", not "a
// copy cannot be made".
export function FieldTechDocuments() {
  const isMobile = useIsMobile();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/training-documents/`)
      .then((res) => {
        setDocuments(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Documents</div>
      </div>
      <div style={styles.content}>
        <div style={styles.card}>
          {loading ? (
            <div style={styles.loading}>Loading...</div>
          ) : documents.length === 0 ? (
            <div style={styles.loading}>
              No documents shared with you yet.
            </div>
          ) : (
            documents.map((doc) => (
              <a
                key={doc.id}
                href={doc.file_url}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  padding: isMobile ? "16px" : "14px 16px",
                  borderBottom: `1px solid ${colors.border}`,
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <LuFileText
                  size={22}
                  style={{ color: colors.slate, flexShrink: 0 }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: isMobile ? "15px" : "14px",
                      color: colors.text,
                    }}
                  >
                    {doc.title}
                  </div>
                  {doc.description && (
                    <div
                      style={{
                        fontSize: "13px",
                        color: colors.slate,
                        marginTop: "3px",
                      }}
                    >
                      {doc.description}
                    </div>
                  )}
                  <div
                    style={{ fontSize: "11px", color: "#aaa", marginTop: "4px" }}
                  >
                    {[formatSize(doc.file_size), formatDate(doc.created_at)]
                      .filter(Boolean)
                      .join(" · ")}
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: colors.slate,
                    whiteSpace: "nowrap",
                  }}
                >
                  Open
                </span>
              </a>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
